let queryParams = null;
let searchHistoryTimeout = null

export default async function (cfg, query, locale, $t, base, $http) {
  const data = await fetchFilterData(locale, base)
  queryParams = query

  return {
    page: 1,
    busy: false,
    open: false,
    appendData: false,
    rawVehicles: [],
    result: [],
    total: 0,
    $t: parseTranslations(cfg),
    queryString() {
      const params = new URLSearchParams();

      if (cfg.user_favorites) {
        params.append("favourites", true)
        return params
      }

      if (cfg.specials_of_the_week) {
        params.append("specials_of_the_week", true)
        params.append("order_by", "-approved_datetime")
        return params
      }
      // Handle empty case and don't fetch all!
      if (this.query.personal.active.size) {
        if (this.query.personal.active.has("recent")) {
          const list = JSON.parse(localStorage.getItem("recently_viewed") ?? '[]')
          params.append("ids", list.join(","))
          return params
        }
        if (this.query.personal.active.has("favourites")) {
          params.append("favourites", true)
          return params
        }
      }

      if (cfg.similar_to) {
        params.append("similar_to", cfg.similar_to)
      }

      if (cfg.carify_exclusive) {
        params.append("carify_exclusive", true)
      }

      for (const [key, entry] of Object.entries(this.query)) {
        if (entry.active.size > 0) {
          params.append(key, [...entry.active])
        }
      }
      if (this.page > 1) {
        params.append("offset", (this.page - 1) * cfg.per_page)
      }

      const package_types = params.get('package_types')
      if (package_types == 'try_and_buy') {
        params.delete('apply_down_payment')
      }

      return params
    },
    applySearch(v) {
      const c = v.trim()
      if (c === "") {
        this.query.search.active.clear()
      } else {
        this.query.search.active = new Set([v])
      }

    },
    saveRecentSearch(term, originalTerm) {
        if (searchHistoryTimeout) clearTimeout(searchHistoryTimeout)

        searchHistoryTimeout = setTimeout(() => {
          const saved = localStorage.getItem('search_history')
          let history = saved ? JSON.parse(saved) : []
          // Check if any existing item in history already contains the
          // newly typed term to prevent saving partial matches
          const hasBetterMatch = history.some(existingItem => existingItem.toLowerCase().includes(term))
          // If a match is found (e.g., "jeep" exists and user typed "jee"), abort saving
          if (hasBetterMatch) return
          // Otherwise, save it normally
          history = [originalTerm, ...history.filter(item => item !== originalTerm)].slice(0, 20)
          localStorage.setItem('search_history', JSON.stringify(history))
          window.dispatchEvent(new Event('search_history_updated'))
        }, 2500)
    },
    get totalPages() {
      if (this.total <= 0) return 0;
      return Math.ceil(this.total / cfg.per_page)
    },
    get pills() {
      const bar = []
      for (const [_, entry] of Object.entries(this.query)) {
        if (!entry.hidden && entry.pills) {
          bar.push(...entry.pills)
        }
      }
      return bar
    },
    clearAll() {
      // search.value.value = '';
      // cache.clear()

      // Clear models manually, since hidden is based on
      // if brands have been selected, so it might fall under
      // continue in loop
      this.resetModels()

      for (const entry of Object.values(this.query)) {
        if (!entry.clearable || entry.hidden) continue;
        entry.active.clear()
      }
    },
    clearFilter(key) {
      this.query[key].active.clear()
      if (key === "makes") {
        this.resetModels()
      }
    },
    deleteFilter(key, val) {
      this.query[key].active.delete(val)
      // if (e.currentTarget.dataset.key == "km") {
      //   this.query.minimum_duration.value.clear()
      // }
      // if (e.currentTarget.dataset.key == "minimum_duration") {
      //   this.query.km.value.clear()
      // }
      // Bind to model?
      // if (e.currentTarget.dataset.key == "search") {
      //   search.value.value = '';
      // }
    },
    resetModels() {
      this.query.models.active.clear()
      this.query.models.options = [];
      this.query.models.hidden = true
    },
    get activeCount() {
      let count = 0;
      for (const entry of Object.values(this.query)) {
        if (entry.clearable && !entry.hidden && entry.active.size > 0) {
          count++
        }
      }
      return count
    },
    openPack: false,
    query: {
      // Unique
      search: initSearch(cfg, $t),
      order_by: initSorting(cfg, $t),
      limit: initPagination(cfg, $t),
      // Core
      package_types: initPackageTypes(cfg, $t),
      km: initKM(cfg, data.packs, $t),
      minimum_duration: initDuration(cfg, $t),
      // Other
      lease_package_price_range: initPriceRange(cfg, $t),
      available_in_days_range: initAvailability(cfg, $t),
      car_types: initBodyTypes(cfg, data.enums.car_type_options, $t),
      fuel_types: initFuelTypes(cfg, data.enums.fuel_type_options, $t),
      transmissions: initTransmission(cfg, data.enums.transmission_options, $t),
      registration_years: initYears(cfg, $t),
      horse_power_range: initPower(cfg, $t),
      drive_types: initDriveTypes(cfg, data.enums.drive_train_options, $t),
      cantons: initCantons(cfg, data.enums.cantons, $t),
      no_of_seats: initSeats(cfg, $t),
      makes: initMakes(cfg, data.makes, $t),
      models: await initModels(cfg, $t, locale, $http),
      personal: initPersonal(cfg, $t),
      equipment: initEquipment(cfg, $t),
      dealer_id: initDealers(cfg, $t),
      apply_down_payment: initDownPayment(cfg, $t),
      on_promotion: initPromotion(cfg, $t)
    }

  }
}

const parseTranslations = (cfg) => {
  const results = {}
  Object.keys(cfg)
    .filter(key => key.startsWith("locale_"))
    .reduce((obj, key) => {
      const k = key.replace("locale_", "")
      results[k] = cfg[key]; return obj;
    }, {})

  return results
}

const fetchFilterData = async (locale, base) => {

  const dataEndpoints = [
    useFetch(`${base}/public_api/vehicles/makes/?lang=${locale}`, { headers: { "Accept-Language": locale } }),
    useFetch(`${base}/public_api/vehicles/enums/?lang=${locale}`, { headers: { "Accept-Language": locale } }),
    useFetch(`${base}/public_api/leases/adjustments/?lang=${locale}`, { headers: { "Accept-Language": locale } }),
  ];

  const responses = await Promise.all(dataEndpoints);

  const { data: { value: { results: makes } } } = responses[0]
  const { data: { value: { results: enums } } } = responses[1]
  const { data: { value: { results: packs } } } = responses[2]

  return { makes, enums, packs }

}

const extractQueryParam = (key, value, validOptions) => {
  let splitVal = true;
  if (['horse_power_range', 'available_in_days_range', 'no_of_seats', 'lease_package_price_range', 'apply_down_payment'].includes(key)) {
    splitVal = false
  }

  let parsed = new Set();
  if (typeof value === "string" && value !== "") {
    parsed = new Set(splitVal ? value.split(",") : [value])
  } else if (typeof value === "string") {
    parsed = new Set()
  } else if (typeof value === "object") {
    parsed = new Set(value)
  } else if (typeof value === "boolean") {
    parsed.add(value.toString())
  }

  if (queryParams.has(key)) {
    const val = queryParams.get(key)
    if (val == 'null' || val == '') {
      parsed = new Set()
    }
    if (splitVal) {
      let split = queryParams.get(key).split(",");
      if (key === "models") {
        const up = split.map(v => v.toUpperCase())
        parsed = new Set(up)
      } else {
        parsed = new Set(split)
      }
    } else {
      parsed = new Set([queryParams.get(key)])
    }
  }

  // Sanitize set to only include valid filter options
  if (validOptions) {
    const intersection = new Set([...parsed].filter(item => validOptions.includes(item)));
    parsed = intersection
  }

  return parsed;
}

const initPackageTypes = (cfg, $t) => {

  const options = [
    { name: $t('package.fixed'), value: "fixed" },
    { name: "Flex", value: "flex" },
    { name: "Try & Buy", value: "try_and_buy" }
  ];

  return {
    name: $t('filter.package_options'),
    type: "package",
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('package_types'),
    options: options,
    active: extractQueryParam("package_types", cfg.filter_package, options.map(o => o.value)),
    get pills() {
      return [...this.active].map(v => ({ text: String(v).charAt(0).toUpperCase() + String(v).slice(1).replaceAll("_", " "), key: 'package_types', val: v }))
    },
  }
}

const initDownPayment = (cfg, $t) => {
  return {
    name: $t('filter.apply_down_payment'),
    type: "noop",
    multi: false,
    clearable: false,
    hidden: cfg.hidden_filters.includes('down_payment'),
    active: extractQueryParam("apply_down_payment", cfg.filter_down_payment),
  }
}


const initPromotion = (cfg, $t) => {
  return {
    name: $t('filter.promotions_toggle'),
    type: "noop",
    multi: false,
    clearable: false,
    hidden: cfg.hidden_filters.includes('promotions'),
    active: extractQueryParam("on_promotion", cfg.filter_on_promotion),
  }
}

const initKM = (cfg, packs, $t) => {
  // Set kilometers options
  const leases = packs.filter(l => l.km_adjustment != 0).map(a => {
    return { name: a.name, value: (1750 + a.km_adjustment).toString() }
  });
  leases.push({ name: "1750 KM", value: "1750" });
  leases.sort((a, b) => a.value - b.value)

  return {
    name: $t('filter.km_per_month'),
    type: "noop",
    clearable: true,
    multi: false,
    hidden: cfg.hidden_filters.includes('km'),
    active: extractQueryParam("km", cfg.filter_km, leases.map(l => l.value)),
    options: leases,
    get pills() {
      return [...this.active].map(v => ({ text: `${v} KM`, key: 'km', val: v }))
    },
    min() {
      return Math.min(...this.options.map(o => o.value)).toString()
    },
  }
}

const initDuration = (cfg, $t) => {

  const options = [
    { value: "1", name: `Min. 1 ${$t('month', 1)}` },
    { value: "3", name: `Min. 3 ${$t('month', 2)}` },
    { value: "6", name: `Min. 6 ${$t('month', 2)}` },
    { value: "12", name: `Min. 12 ${$t('month', 2)}` },
    { value: "18", name: `Min. 18 ${$t('month', 2)}` },
    { value: "24", name: `Min. 24 ${$t('month', 2)}` },
    { value: "36", name: `Min. 36 ${$t('month', 2)}` },
    { value: "48", name: `Min. 48 ${$t('month', 2)}` },
  ];

  return {
    name: $t('filter.min_duration'),
    type: "noop",
    clearable: true,
    multi: false,
    hidden: cfg.hidden_filters.includes('minimum_duration'),
    active: extractQueryParam("minimum_duration", cfg.filter_duration, options.map(o => o.value)),
    options: options,
    get pills() {
      return [...this.active].map(v => ({ text: `${v} Month`, key: 'minimum_duration', val: v }))
    },
    max() {
      return Math.max(...this.options.map(o => o.value)).toString()
    },
  }
}


const initPersonal = () => {
  return {
    name: "Personal",
    clearable: true,
    multi: false,
    hidden: true,
    active: new Set(),
    options: [
      { value: "recent", name: "Recently Viewed" },
      { value: "favourites", name: "Favourites" },
    ]
  }
}

const initSearch = (cfg, $t) => {
  return {
    name: $t('search'),
    type: "search",
    clearable: true,
    hidden: cfg.hidden_filters.includes('search'),
    active: extractQueryParam("search", cfg.filter_search),
    get pills() {
      return [...this.active].map(v => ({ text: `${this.name}: ${v}`, key: 'search', val: v }))
    },
  }
}

const initSorting = (cfg, $t) => {
  return {
    name: $t('filter.sorting'),
    clearable: false,
    hidden: cfg.hidden_filters.includes('order_by'),
    type: "noop",
    get value() {
      const v = [...this.active][0]
      return this.options.find(o => o.value === v)
    },
    set value(v) {
      this.active = new Set([v.value])
    },
    active: new Set([cfg.sorting]),
    options: [
      { value: "-top_picks", name: $t('filter.sort_recommend') },
      { value: "+base_price", name: $t('filter.sort_low_high') },
      { value: "-base_price", name: $t('filter.sort_high_low') },
      { value: "-approved_datetime", name: $t('filter.sort_new_old') },
      { value: "+approved_datetime", name: $t('filter.sort_old_new') },
      { value: "-rank", name: $t('filter.sort_relevance') },
      // { value: "-has_promo", name: "Promotions" },
    ]
  }
}

const initPagination = (cfg) => {
  return {
    name: "Limit",
    clearable: false,
    hidden: true,
    active: new Set([cfg.per_page]),
  }
}

const initDealers = (cfg, $t) => {
  return {
    name: $t('filter.dealers'),
    type: "noop",
    clearable: false,
    hidden: true,
    active: extractQueryParam("dealer_id", cfg.filter_dealer_id),
  }
}

// Initialise registration years filter
const initYears = (cfg, $t) => {
  const max = new Date().getFullYear()
  const min = max - 5
  const years = []
  for (let i = max; i >= min; i--) {
    years.push({ value: i.toString(), name: i.toString() })
  }

  return {
    name: $t('filter.registration_year'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('years'),
    options: years,
    active: extractQueryParam("registration_years", cfg.filter_years, years.map(y => y.value)),
    get pills() {
      return [...this.active].map(v => ({ text: v.toUpperCase(), key: 'registration_years', val: v }))
    },
  }
}

// Initialize number of seats filter
const initSeats = (cfg, $t) => {
  const seats = []
  for (let i = 2; i < 10; i++) {
    seats.push({ value: i.toString(), name: i.toString() })
  }

  return {
    name: $t('filter.number_of_seats'),
    multi: false,
    clearable: true,
    hidden: cfg.hidden_filters.includes('no_of_seats'),
    active: extractQueryParam("no_of_seats", cfg.filter_no_of_seats, seats.map(s => s.value)),
    options: seats,
    circle: true,
    get pills() {
      return [...this.active].map(v => ({ text: `Seats: ${v}`, key: 'no_of_seats', val: v }))
    },
  }
}

// Initialize makes/brands
const initMakes = (cfg, makes, $t) => {

  return {
    cols: 2,
    name: $t('filter.brands'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('makes'),
    active: extractQueryParam("makes", cfg.filter_brands, makes.map(m => m.name.replace(" ", "-"))),
    options: makes.map((m) => ({ value: m.name.toUpperCase(), name: m.name })),
    get pills() {
      return [...this.active].map(v => ({ text: v.toUpperCase(), key: 'makes', val: v }))
    },
  }
}


const initModels = async (cfg, $t, locale, $http) => {
  let hidden = true
  const models = [];
  if (queryParams.has("makes")) {
    hidden = false
    const mk = queryParams.get("makes")
    await $http(`public_api/vehicles/models/?makes=${mk}`, { method: "GET" }).then(({ data }) => {
      if (!data) { return } // safe guard for error response.
      data.forEach(brand => {
        brand.models.forEach(m => {
          models.push({ name: `${m.name} (${brand.name})`, value: m.name.toUpperCase(), brand: brand.name.toUpperCase() })
        })
      })
    })
  }

  return {
    cols: 2,
    name: $t('filter.models'),
    multi: true,
    clearable: true,
    hidden: hidden,
    active: extractQueryParam("models", []),
    options: models,
    get pills() {
      return [...this.active].map(v => ({ text: v.toUpperCase(), key: 'models', val: v }))
    },
  }
}


const initDriveTypes = (cfg, ops, $t) => {
  return {
    name: $t('filter.drive_train'),
    multi: false,
    clearable: true,
    hidden: cfg.hidden_filters.includes('drive_types'),
    active: extractQueryParam("drive_types", cfg.filter_drive_types, Object.keys(ops)),
    options: Object.entries(ops).map(e => ({ value: e[0], name: e[1] })),
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: d.name, key: 'drive_types', val: d.value }
      })
    },
  }
}

const initPower = (cfg, $t) => {

  const options = [
    { value: "0,100", name: "0-100" },
    { value: "101,200", name: "101-200" },
    { value: "201,300", name: "201-300" },
    { value: "301,2500", name: "300+" },
  ];

  return {
    name: $t('filter.horse_power'),
    multi: false,
    clearable: true,
    hidden: cfg.hidden_filters.includes('horse_power_range'),
    active: extractQueryParam("horse_power_range", cfg.filter_horse_power_range, options.map(o => o.value)),
    options: options,
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: `Power: ${d.name}`, key: 'horse_power_range', val: d.value }
      })
    },
  }
}

const initPriceRange = (cfg, $t) => {

  const options = [
    { value: "200,650", name: "&le;650" },
    { value: "651,850", name: "&le;850" },
    { value: "200,1000", name: "&le;1000" },
    { value: "1001,10000", name: "&gt;1000" },
  ];

  return {
    name: $t('filter.price_range'),
    multi: false,
    clearable: true,
    hidden: cfg.hidden_filters.includes('lease_package_price_range'),
    active: extractQueryParam("lease_package_price_range", cfg.filter_price_range, options.map(o => o.value)),
    options: options,
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: `Price Range: ${d?.name}`, key: 'lease_package_price_range', val: d.value }
      })
    },
  }
}


const initCantons = (cfg, ops, $t) => {
  return {
    name: $t('filter.cantons'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('cantons'),
    active: extractQueryParam("cantons", cfg.filter_cantons, Object.values(ops)),
    options: ops.map(o => ({ value: o, name: o })),
    get pills() {
      return [...this.active].map(v => ({ text: v, key: 'cantons', val: v }))
    },
  }
}


const initFuelTypes = (cfg, ops, $t) => {
  // Remove 'unknown fuel type' entry
  delete ops[0]
  return {
    name: $t('filter.fuel_types'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('fuel_types'),
    active: extractQueryParam("fuel_types", cfg.filter_fuel_types, Object.keys(ops)),
    options: Object.entries(ops).map(e => ({ value: e[0], name: e[1] })),
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: d.name, key: 'fuel_types', val: d.value }
      })
    },
  }
}

const initAvailability = (cfg, $t) => {

  const options = [
    { value: "9,14", name: `9-14 ${$t('filter.days')}` },
    { value: "14,28", name: `14 - 28 ${$t('filter.days')}` },
    { value: "28,40", name: `28 - 40 ${$t('filter.days')}` },
  ];

  return {
    name: $t('filter.availability'),
    multi: false,
    clearable: true,
    hidden: cfg.hidden_filters.includes('available_in_days_range'),
    active: extractQueryParam("available_in_days_range", cfg.filter_availability, options.map(o => o.value)),
    options: options,
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: `Availability: ${d.name}`, key: 'available_in_days_range', val: d.value }
      })
    },
  }
}

const initTransmission = (cfg, ops, $t) => {
  return {
    name: $t('filter.transmission'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('transmissions'),
    active: extractQueryParam("transmissions", cfg.filter_transmission, Object.keys(ops)),
    options: Object.entries(ops).map(e => ({ value: e[0], name: e[1] })),
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: d.name, key: 'transmissions', val: d.value }
      })
    },
  }
}

const initBodyTypes = (cfg, ops, $t) => {
  return {
    name: $t('filter.body_types'),
    multi: true,
    clearable: true,
    hidden: cfg.hidden_filters.includes('car_types'),
    active: extractQueryParam("car_types", cfg.filter_body_types, Object.keys(ops)),
    options: Object.entries(ops).map(e => ({ value: e[0], name: e[1] })),
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: d.name, key: 'car_types', val: d.value }
      })
    }
  }
}

const initEquipment = (cfg, $t) => {

  const options = [
    { value: "Alloy wheels", name: $t('search_alerts.alloy_wheels') },
    { value: "Isofix", name: $t('search_alerts.isofix') },
    { value: "Rear view camera", name: $t('search_alerts.rear_wheel_camera') },
    { value: "360° camera", name: $t('search_alerts.360_camera') },
    { value: "Android Auto", name: $t('search_alerts.android_auto') },
    { value: "Apple CarPlay", name: $t('search_alerts.apple_car_play') },
    { value: "Bluetooth interface", name: $t('search_alerts.bluetooth') },
    { value: "Cruise control", name: $t('search_alerts.cruise_control') },
    { value: "Heated seats", name: $t('search_alerts.heated_seats') },
    { value: "Front parking sensor", name: $t('search_alerts.front_parking_sensors') },
    { value: "Rear parking sensors", name: $t('search_alerts.rear_parking_sensors') },
    { value: "Tow Bar", name: $t('search_alerts.tow_bar') },
    { value: "Sliding Roof", name: $t('search_alerts.sliding_roof') },
    { value: "Panoramic roof", name: $t('search_alerts.panoramic_roof') }
  ];

  return {
    clearable: true,
    name: $t('filter.equipment'),
    multi: true,
    hidden: cfg.hidden_filters.includes('equipment'),
    active: extractQueryParam("equipment", cfg.filter_equipment, options.map(o => o.value)),
    options: options,
    get pills() {
      return [...this.active].map(v => {
        const d = this.options.find(o => o.value === v)
        return { text: d.name, key: 'equipment', val: d.value }
      })
    }
  }
}
